import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/dropzone/styles.css';
import '@mantine/notifications/styles.css';
import '@mantine/nprogress/styles.css';
import '@mantine/tiptap/styles.css';
import 'mantine-datatable/styles.css';

import App from '@/App';
import { initDayJs } from '@/shared/utils/date-utils';
import { initNumeral } from '@/shared/utils/number-utils';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

const version = import.meta.env.PACKAGE_VERSION;
const mode = import.meta.env.MODE;

initDayJs();
initNumeral();

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

console.log(
  `%c ORU Espace Pro - version ${version} (${mode}) `,
  'background: #a00; color: white; padding: 4px 8px; border-radius: 4px;',
);

declare global {
  interface Window {
    env: any;
  }
}

window.env = import.meta.env;
